var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQaImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 529.224,
    height: 350.469,
    viewBox: "0 0 529.224 350.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.05;}.b{fill:#3f3d56;}.c{fill:#ccc;}.d{fill:#ee0a6b;}.e{fill:#f2f2f2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-73.97)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M464.3,481.241,342.529,506.908a13.577,13.577,0,0,1-16.067-10.473L305.567,397.3a13.577,13.577,0,0,1,10.473-16.067l121.769-25.667a13.576,13.576,0,0,1,16.066,10.473l20.9,99.132A13.576,13.576,0,0,1,464.3,481.241ZM316.368,382.8a11.979,11.979,0,0,0-9.241,14.176l20.9,99.132a11.979,11.979,0,0,0,14.176,9.241L463.968,479.68a11.979,11.979,0,0,0,9.241-14.176l-20.9-99.132a11.979,11.979,0,0,0-14.177-9.241Z",
    transform: "translate(-231.305 -213.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M445.675,395.524l-61.455,12.954a2.179,2.179,0,0,1-2.576-1.486,2.1,2.1,0,0,1,1.594-2.6L445.8,391.21c2.443,1.376,1.671,3.937-.121,4.315Z",
    transform: "translate(-246.739 -221.128)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M448.524,409.037l-61.455,12.954a2.178,2.178,0,0,1-2.576-1.486,2.1,2.1,0,0,1,1.594-2.6l62.557-13.186c2.443,1.377,1.671,3.937-.121,4.315Z",
    transform: "translate(-247.315 -223.861)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M366.047,430.778l-18.756,3.953a2.363,2.363,0,0,1-2.8-1.823l-4.665-22.133a2.363,2.363,0,0,1,1.823-2.8l18.756-3.953a2.364,2.364,0,0,1,2.8,1.823l4.665,22.133a2.363,2.363,0,0,1-1.823,2.8Z",
    transform: "translate(-238.284 -223.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M445.933,436.753l-93.792,19.769a2.178,2.178,0,0,1-2.576-1.486,2.1,2.1,0,0,1,1.594-2.6l94.9-20c2.443,1.377,1.671,3.937-.121,4.315Z",
    transform: "translate(-240.249 -229.467)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M448.782,450.27,354.99,470.039a2.178,2.178,0,0,1-2.576-1.486,2.1,2.1,0,0,1,1.594-2.6l94.9-20c2.443,1.377,1.671,3.937-.121,4.315Z",
    transform: "translate(-240.826 -232.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M451.629,463.778l-93.792,19.77a2.179,2.179,0,0,1-2.576-1.486,2.1,2.1,0,0,1,1.594-2.6l94.9-20c2.443,1.376,1.671,3.937-.121,4.315Z",
    transform: "translate(-241.402 -234.934)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M454.478,477.294l-93.792,19.77a2.178,2.178,0,0,1-2.576-1.486,2.1,2.1,0,0,1,1.594-2.6l94.9-20c2.443,1.377,1.671,3.937-.121,4.315Z",
    transform: "translate(-241.978 -237.668)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M457.325,490.8l-93.791,19.77a2.179,2.179,0,0,1-2.576-1.486,2.1,2.1,0,0,1,1.594-2.6l94.9-20c2.443,1.377,1.671,3.937-.121,4.315Z",
    transform: "translate(-242.554 -240.401)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M691.7,319.433H567.256A13.577,13.577,0,0,1,553.7,305.872V204.561A13.577,13.577,0,0,1,567.256,191H691.7a13.577,13.577,0,0,1,13.561,13.561V305.872A13.577,13.577,0,0,1,691.7,319.433ZM567.256,192.6a11.979,11.979,0,0,0-11.966,11.966V305.872a11.979,11.979,0,0,0,11.966,11.966H691.7a11.979,11.979,0,0,0,11.966-11.966V204.561A11.979,11.979,0,0,0,691.7,192.6Z",
    transform: "translate(-281.555 -180.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M692.475,228.074H629.67a2.178,2.178,0,0,1-2.214-1.986,2.1,2.1,0,0,1,2.1-2.211h63.932c2.106,1.851.823,4.2-1.009,4.2Z",
    transform: "translate(-296.475 -187.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M692.475,241.884H629.67a2.179,2.179,0,0,1-2.214-1.986,2.1,2.1,0,0,1,2.1-2.211h63.932c2.106,1.851.823,4.2-1.009,4.2Z",
    transform: "translate(-296.475 -190.073)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M607.753,243.878H588.585a2.363,2.363,0,0,1-2.36-2.36V218.9a2.363,2.363,0,0,1,2.36-2.36h19.168a2.364,2.364,0,0,1,2.36,2.36v22.619a2.363,2.363,0,0,1-2.36,2.361Z",
    transform: "translate(-288.135 -185.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M683.866,270.16H588.014a2.178,2.178,0,0,1-2.214-1.986,2.1,2.1,0,0,1,2.1-2.211h96.98c2.106,1.851.823,4.2-1.009,4.2Z",
    transform: "translate(-288.049 -195.793)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M683.866,283.974H588.014a2.178,2.178,0,0,1-2.214-1.986,2.1,2.1,0,0,1,2.1-2.211h96.98c2.106,1.851.823,4.2-1.009,4.2Z",
    transform: "translate(-288.049 -198.587)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M683.866,297.779H588.014a2.178,2.178,0,0,1-2.214-1.986,2.1,2.1,0,0,1,2.1-2.211h96.98c2.106,1.851.823,4.2-1.009,4.2Z",
    transform: "translate(-288.049 -201.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M683.866,311.592H588.014a2.178,2.178,0,0,1-2.214-1.986,2.1,2.1,0,0,1,2.1-2.211h96.98c2.106,1.851.823,4.2-1.009,4.2Z",
    transform: "translate(-288.049 -204.174)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M683.866,325.4H588.014a2.178,2.178,0,0,1-2.214-1.986,2.1,2.1,0,0,1,2.1-2.211h96.98c2.106,1.851.823,4.2-1.009,4.2Z",
    transform: "translate(-288.049 -206.967)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M673.883,178a3.993,3.993,0,0,1,3.989,3.989v12.764a3.993,3.993,0,0,1-3.989,3.989h-70.2a3.993,3.993,0,0,1-3.989-3.989V181.989A3.993,3.993,0,0,1,603.684,178",
    transform: "translate(-290.86 -178)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M916.7,476.433H792.256a13.577,13.577,0,0,1-13.561-13.561V361.561A13.576,13.576,0,0,1,792.256,348H916.7a13.576,13.576,0,0,1,13.561,13.561V462.872A13.576,13.576,0,0,1,916.7,476.433ZM792.256,349.6a11.979,11.979,0,0,0-11.966,11.966V462.872a11.979,11.979,0,0,0,11.966,11.966H916.7a11.979,11.979,0,0,0,11.966-11.966V361.561A11.98,11.98,0,0,0,916.7,349.6Z",
    transform: "translate(-327.068 -212.387)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M917.475,385.074H854.67a2.179,2.179,0,0,1-2.214-1.986,2.1,2.1,0,0,1,2.1-2.211h63.932c2.106,1.851.823,4.2-1.009,4.2Z",
    transform: "translate(-341.988 -219.038)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M917.475,398.884H854.67a2.179,2.179,0,0,1-2.214-1.986,2.1,2.1,0,0,1,2.1-2.211h63.932c2.106,1.851.823,4.2-1.009,4.2Z",
    transform: "translate(-341.988 -221.831)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M832.753,400.878H813.585a2.363,2.363,0,0,1-2.36-2.361V375.9a2.363,2.363,0,0,1,2.36-2.36h19.168a2.364,2.364,0,0,1,2.36,2.36v22.619A2.363,2.363,0,0,1,832.753,400.878Z",
    transform: "translate(-333.648 -217.553)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M927.753,480.306H908.585a2.363,2.363,0,0,1-2.36-2.36V464.9a2.363,2.363,0,0,1,2.36-2.36h19.168a2.363,2.363,0,0,1,2.36,2.36v13.047A2.363,2.363,0,0,1,927.753,480.306Z",
    transform: "translate(-352.865 -235.556)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M908.866,427.16H813.014a2.178,2.178,0,0,1-2.214-1.986,2.1,2.1,0,0,1,2.1-2.211h96.98c2.106,1.851.823,4.2-1.009,4.2Z",
    transform: "translate(-333.562 -227.551)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M908.866,440.974H813.014a2.178,2.178,0,0,1-2.214-1.985,2.1,2.1,0,0,1,2.1-2.211h96.98c2.106,1.851.823,4.2-1.009,4.2Z",
    transform: "translate(-333.562 -230.345)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M908.866,454.779H813.014a2.178,2.178,0,0,1-2.214-1.986,2.1,2.1,0,0,1,2.1-2.211h96.98c2.106,1.851.823,4.2-1.009,4.2Z",
    transform: "translate(-333.562 -233.138)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M858.61,468.592h-45.6a2.178,2.178,0,0,1-2.214-1.986,2.1,2.1,0,0,1,2.1-2.211h46.724c2.106,1.851.823,4.2-1.009,4.2Z",
    transform: "translate(-333.562 -235.932)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M858.61,482.4h-45.6a2.178,2.178,0,0,1-2.214-1.986,2.1,2.1,0,0,1,2.1-2.211h46.724c2.106,1.851.823,4.2-1.009,4.2Z",
    transform: "translate(-333.561 -238.724)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M898.883,355.741h-70.2a3.993,3.993,0,0,1-3.989-3.989V338.989A3.993,3.993,0,0,1,828.684,335h70.2a3.993,3.993,0,0,1,3.989,3.989v12.764a3.993,3.993,0,0,1-3.989,3.989Z",
    transform: "translate(-336.373 -209.758)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(86.994 13.448)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(86.994 34.007)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(86.994 54.567)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(86.994 75.127)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(108.533 13.448)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(108.533 34.007)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(108.533 54.567)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(108.533 75.127)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(130.072 13.448)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(130.072 34.007)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(130.072 54.567)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(130.072 75.127)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(151.61 13.448)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(151.61 34.007)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(151.61 54.567)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(151.61 75.127)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(173.148 13.448)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(173.148 34.007)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(173.148 54.567)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(173.148 75.127)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(194.687 13.448)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(194.687 34.007)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(194.687 54.567)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(194.687 75.127)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(489.844 299.031)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(489.844 319.592)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(489.844 340.151)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(511.382 299.031)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(511.382 319.592)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(511.382 340.151)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(532.921 299.031)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(532.921 319.592)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(532.921 340.151)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(554.459 299.031)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(554.459 319.592)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.159,
    cy: 5.159,
    r: 5.159,
    transform: "translate(554.459 340.151)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQaImg2);
export default __webpack_public_path__ + "static/media/q&a_img_2.5962f4028981ac0eb89248f9995fff51.svg";
export { ForwardRef as ReactComponent };